<template>
    <el-container>

        <el-header height="100px">
            <div>
                <img src="../assets/img/topLogo.jpg" alt="">
            </div>
            <h2>橙蟹后台管理系统</h2>
            <a @click="logout">登出</a>
        </el-header>

        <el-container>
            <el-aside width="200px">
                <el-menu v-for="item in navList" :key="item.navId" router class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                    <el-submenu :index="item.navId">
                        <template slot="title">
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item v-for="(json,i) in item.childrenList" :key="i" :index="json.childNavPath">
                            {{json.title}}
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-container>

                <el-main>
                    <router-view></router-view>
                </el-main>

            </el-container>
        </el-container>
    </el-container>
</template>

<script>
    export default {
        name: 'htHome',
        data() {
            return {
                navList: [
                {
                    title: '首页',
                    navId: '1',
                    childrenList: [
                    {
                        title: '解决方案',
                        childNavPath: '/ht_scheme'
                    },
                    {
                        title: '体验财务顾问',
                        childNavPath: '/ht_experience'
                    },
                    {
                        title: '活动印花',
                        childNavPath: '/ht_activity'
                    }]
                },
                {
                    title: '客户服务',
                    navId: '2',
                    childrenList: [
                    {
                        title: '服务案例',
                        childNavPath: '/ht_serverInfo'
                    }]
                },
                {
                    title: '顾问招募',
                    navId: '3',
                    childrenList: [
                    {
                        title: '预约报名',
                        childNavPath: '/ht_apply'
                    },
                    {
                        title: '往期回顾',
                        childNavPath: '/ht_review'
                    }, ]
                },
                {
                    title: '关于橙蟹',
                    navId: '4',
                    childrenList: [
                    {
                        title: '企业资讯',
                        childNavPath: '/ht_enterpriseInfo'
                    },
                    {
                        title: '加入我们',
                        childNavPath: '/ht_joinWe'
                    }, ]
                }]
            }
        },
        methods: {
            logout() {
                sessionStorage.removeItem('token');
                this.$router.push('/backstage');
            }
        }
    }
</script>

<style scoped>
    .el-header {
        background-color: #1b9ad5;
        display: flex;
        justify-content: space-between;
        line-height: 100px;
    }

    .el-header h2 {
        font-size: 32px;
        color: #2e324f;
    }

    .el-header div {
        padding-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/htHome.vue